<template>
  <QuestionBase
      :showQuestion="false"
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="true"
  >
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";
import {personHelpers} from "@/mixins/personHelpers";

import QuestionBase from "../../../../QuestionBase";

export default {
  name: 'VehicleText',
  mixins: [questionLoadHelpers, saveHelpers, personHelpers],
  components: {
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      required: false
    },
    giftDetails: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
        if (this.noSave) return
        this.$nextTick(() => {
          this.save()
        })
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Text?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: `${this.location}${this.index}CashText`,
        formPath: `data.${this.location}.details.gifts.${this.index}.text`,
        jsonSaveField: 'text'
      },
      args: {
        skippable: false,
        required: false,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  },
  methods: {
    setText() {
      this.$nextTick(() => {
        if (this.giftDetails.vehicleType === 'all') {
          this.data = 'any motor vehicles owned by me at my death and all accessories for them'
        } else if (this.giftDetails.vehicleType === 'car') {
          this.data = `the vehicle ${this.giftDetails.vehicleMake} ${this.giftDetails.vehicleModel} owned by me at my death and all accessories for it`
        } else if (this.giftDetails.vehicleType === 'boat') {
          this.data = `the boat ${this.giftDetails.vehicleName} ${this.giftDetails.vehicleMake} ${this.giftDetails.vehicleModel} owned by me at my death and all accessories for it`
        } else if (this.giftDetails.vehicleType === 'caravan') {
          this.data = `the caravan ${this.giftDetails.vehicleMake} ${this.giftDetails.vehicleModel} owned by me at my death and all accessories for it`
        } else if (this.giftDetails.vehicleType === 'custom') {
          this.data = this.giftDetails.userCustomText
        }
      })
    }

  }
}
</script>